export const antdThemeTokenConfig = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  colorPrimary: '#4F46E5',
  colorError: '#EF4444',
  borderRadiusLG: 6,
  colorTextPlaceholder: '#9CA3AF',
  colorErrorBorder: '#FCA5A5'
};